var exports = {
  "R": "imageAttachment__xzZEtF",
};

module.exports = exports;
